import React from 'react';
import './Spinner.css';

export const Spinner = () => {
  return <div className="spinner"></div>;
};

export const FullPageSpinner = () => {
  return (
    <div className="full-page-spinner-overlay">
      <Spinner />
    </div>
  )
}